import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SnackbarComponent } from 'app/snackbar/snackbar.component';
import { ApiService } from 'app/ts/ApiService';
import { ClientStoreService } from 'app/ts/services/client-store.service';


@Component({
  selector: 'app-credit-report',
  templateUrl: './credit-report.component.html',
  styleUrls: ['./credit-report.component.scss', '../../forms.shared.scss']
})
export class CreditReportComponent implements OnInit {

  
  
    @Output() updateStepEvent = new EventEmitter<number>();
    @Output() previousStepEvent = new EventEmitter<number>();

    loading = false;
    pdf: SafeResourceUrl | null = null;
    creditReportReceived: boolean = false;
    pdfBase64: string = '';
    

    constructor(
      private fb: FormBuilder, 
      private snackbar: MatSnackBar, 
      private api: ApiService, 
      private sanitizer: DomSanitizer,
      private clientStore: ClientStoreService
    ) {}
    
    creditReport: FormGroup;
    


  ngOnInit() {
    this.clientStore.clearClient();
    this.creditReport = this.fb.group({
      idNumber: ['', [Validators.required, Validators.pattern(/^\d{13}$/)]]
    });
  }



  goToClientDetails() {
    this.updateStepEvent.emit();
  }

  back() {
    this.previousStepEvent.emit();
  }

  downloadPdf() {
    const link = document.createElement('a');
    link.href = "data:application/pdf;base64," + this.pdfBase64;
    var client = this.clientStore.getClient().subscribe(c => {
      if (c) {
        link.download = `credit-report_${c.firstName}_${c.lastName}.pdf`
        }
    });
    // link.download = `credit-report.pdf`;
    link.click();
  }

  generateCreditReport() {
    this.loading = true;

    let staffId = sessionStorage.getItem('staffId');

    this.api.getCreditReport(this.creditReport.value.idNumber, staffId).subscribe(
      (response: any) => {
        if (response.status == 400) {
          this.openSnackBar('An error occurred while fetching the credit report. Please try again.', 'error-snackbar');
          this.pdf = null;
          this.creditReportReceived = false;
          this.loading = false;
          return;
        }
        if (response.pdf?.length > 0) {
          this.clientStore.setClient(response.client);
          this.pdfBase64 = response.pdf;
          const pdf = "data:application/pdf;base64," + response.pdf;
          this.creditReportReceived = true;
          this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(pdf);
        } else {
          this.pdf = null;
          this.creditReportReceived = false;
          this.openSnackBar('No credit report found for the provided ID number.', 'error-snackbar');
        }
        
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching credit report:', error);
        this.pdf = null;
        this.creditReportReceived = false;
        this.loading = false;
        this.openSnackBar('An error occurred while fetching the credit report. Please try again.', 'error-snackbar');
      }
    );
  }


  openSnackBar(msg: string, panel: string) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: msg,
        panelClass: [panel],
        duration: 8000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
    }

}
